import {
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

// Фирменные цвета livedigital (vlprojectslive, client/src/ui-kit/themes: light.colors.tsx, dark.colors.ts).
const brand = {
  navy: '#060A2D',
  navyLight: '#1A2657',
  accentLight: '#163498',
  accentDark: '#1D51FE',
  accentMuted: '#5C71B7',
  accentPale: '#8A99CB',
  secondary: '#B7B9C9',
};

const fontFamily =
  "'PT Root UI', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif";

// Меню одинаково тёмное в обеих темах, как в продукте.
const navigation = {
  background: brand.navy,
  indicator: brand.accentDark,
  color: brand.secondary,
  selectedColor: '#FFFFFF',
  navItem: { hoverBackground: brand.navyLight },
  submenu: { background: brand.navyLight },
};

// Шапки страниц: градиент от тёмно-синего к акценту, свой оттенок и форма для каждого вида страниц.
const pageTheme = {
  home: genPageTheme({ colors: [brand.navy, brand.accentLight], shape: shapes.wave }),
  service: genPageTheme({ colors: [brand.navy, brand.accentDark], shape: shapes.wave }),
  website: genPageTheme({ colors: [brand.navy, brand.accentMuted], shape: shapes.wave }),
  library: genPageTheme({ colors: [brand.navy, brand.accentMuted], shape: shapes.round }),
  apis: genPageTheme({ colors: [brand.navyLight, brand.accentDark], shape: shapes.wave2 }),
  documentation: genPageTheme({ colors: [brand.navyLight, brand.accentLight], shape: shapes.wave2 }),
  tool: genPageTheme({ colors: [brand.navy, brand.accentPale], shape: shapes.round }),
  other: genPageTheme({ colors: [brand.navy, brand.accentLight], shape: shapes.round }),
  app: genPageTheme({ colors: [brand.navy, brand.accentDark], shape: shapes.wave }),
};

export const livedigitalLightTheme = createUnifiedTheme({
  palette: {
    ...palettes.light,
    primary: { main: brand.accentLight },
    secondary: { main: brand.accentDark },
    text: { primary: brand.navy, secondary: '#5C5D6C' },
    link: brand.accentLight,
    linkHover: brand.accentDark,
    navigation,
  },
  fontFamily,
  defaultPageTheme: 'home',
  pageTheme,
});

// В тёмной теме акцент #1D51FE плохо читается как текст на тёмном фоне, поэтому ссылки и текстовые
// элементы берут светлые оттенки акцента из тёмной палитры продукта (accent02/03/04), фон — её bg.
export const livedigitalDarkTheme = createUnifiedTheme({
  palette: {
    ...palettes.dark,
    background: { default: '#1D1D2C', paper: '#262638' },
    primary: { main: '#6185FE' },
    secondary: { main: '#A5B9FF' },
    text: { primary: '#FFFFFF', secondary: '#B7B9C9' },
    link: '#A5B9FF',
    linkHover: '#D2DCFF',
    navigation,
  },
  fontFamily,
  defaultPageTheme: 'home',
  pageTheme,
});
